import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchProcessingFee } from "../../actions/processingfee";
import { fetchProcessingFeeVendor } from "../../actions/processingfeeVendor";
import { getProcessingFeeData, getProcessingFeeVendorData } from "../../selectors"; // prettier-ignore

// prettier-ignore
export function useProcessingFee(paymentMethodSelection) {
  const dispatch = useDispatch();
  const processingFee = useSelector(getProcessingFeeData);
  const processingFeeVendor = useSelector(getProcessingFeeVendorData);

  useEffect(() => {
    dispatch(fetchProcessingFee());
    dispatch(fetchProcessingFeeVendor());
  }, [dispatch]);

  return useMemo(() => {
    if (paymentMethodSelection === "Credit Card or PayPal") {
      const totalProcessingFee = parseFloat(processingFee) + parseFloat(processingFeeVendor);
      return isNaN(totalProcessingFee) ? "0" : totalProcessingFee;
    } else {
      return isNaN(processingFee) ? "0" : processingFee;
    }
  }, [processingFee, processingFeeVendor, paymentMethodSelection]);
}

// prettier-ignore
export function useDonationAmount(originalAmount, processingFeeSelection, finalProcessingFee) {
  return useMemo(() => {
    let amount = undefined;

    if (processingFeeSelection === "radio-yes") {
      const decimalProcessingFee = +finalProcessingFee / 100;
      let calculatedAmount = +originalAmount + +(originalAmount * decimalProcessingFee);
      calculatedAmount = Math.round(calculatedAmount * 100) / 100;
      amount = calculatedAmount.toFixed(2);
    } else {
      amount = parseFloat(originalAmount).toFixed(2);
    }

    if (!amount || isNaN(amount)) {
      return "0.00";
    } else {
      return amount;
    }
  }, [originalAmount, processingFeeSelection, finalProcessingFee]);
}
